import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  AttributeAddUrlQueryParams,
  AttributeListUrlQueryParams,
  AttributeListUrlSortField,
  AttributeUrlQueryParams
} from "./urls";
import AttributeCreateComponent from "./views/AttributeCreate";
import AttributeDetailsComponent from "./views/AttributeDetails";
import AttributeListComponent from "./views/AttributeList";

const AttributeList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    AttributeListUrlSortField
  ) as AttributeListUrlQueryParams;

  return <AttributeListComponent params={params} />;
};

const AttributeCreate: React.FC = () => {
  const location = useLocation();
  const params = parseQueryString<AttributeAddUrlQueryParams>(
    location.search.substr(1)
  );
  return <AttributeCreateComponent params={params} />;
};

const AttributeDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<AttributeUrlQueryParams>(
    location.search.substr(1)
  );
  return (
    <AttributeDetailsComponent id={decodeURIComponent(id)} params={params} />
  );
};

export const AttributeSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.attributes)} />
      <Routes>
        <Route path={""} element={<AttributeList />} />
        <Route path={"add"} element={<AttributeCreate />} />
        <Route path={":id"} element={<AttributeDetails />} />
      </Routes>
    </>
  );
};
export default AttributeSection;
